import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from '../../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { submitAdditionalPqlForm } from '../../pql/submitPql';
import { track } from '../../common/eventTracking/tracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error not migrated to TS

import PhoneNumberInput from 'ui-addon-i18n/components/PhoneNumberInput';
import { CallConfirmationSection } from './CallConfirmationSection';
import { MODAL_TYPES } from '../constants';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
export const GetACallSection = ({
  handleIframeSizeChange,
  onBackClick,
  upgradeData,
  isUpgradePoint,
  repInfo
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isPhoneNumberSubmitted, setIsPhoneNumberSubmitted] = useState(false);

  const handleSubmit = () => {
    submitAdditionalPqlForm(Object.assign({}, upgradeData, {
      isAssignable: true,
      isRetail: false,
      repInfo
    }), {
      phoneNumber
    });
    track('communicationMethodsInteraction', Object.assign({
      action: 'submitted phone number',
      repName: getRepName(repInfo)
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
    handleIframeSizeChange(MODAL_TYPES.PHONE_NUMBER_SUBMITTED);
    setIsPhoneNumberSubmitted(true);
  };

  if (isPhoneNumberSubmitted) {
    return /*#__PURE__*/_jsx(CallConfirmationSection, {});
  }

  const handleInputChange = ({
    phoneNumber: phoneNumberValue
  }) => {
    setPhoneNumber(phoneNumberValue);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "text-center",
    "data-test-id": "communication-selected-method-call",
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.communicationMethods.callTitle"
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(PhoneNumberInput, {
        className: "m-bottom-6",
        style: {
          width: 'auto'
        },
        value: phoneNumber,
        onChange: handleInputChange
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "communication-call-submit-button center-block m-bottom-4",
        onClick: handleSubmit,
        use: "primary",
        disabled: !phoneNumber,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.callButton"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "communication-call-back-button center-block",
        use: "link",
        onClick: () => onBackClick(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.backButton"
        })
      })]
    })]
  });
};
GetACallSection.propTypes = Object.assign({
  handleIframeSizeChange: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  repInfo: PropTypes.object
}, upgradeDataPropsInterface);